import script from "./storage-content.vue?vue&type=script&setup=true&lang=js"
export * from "./storage-content.vue?vue&type=script&setup=true&lang=js"

import "./storage-content.vue?vue&type=style&index=0&id=744d81cd&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.16_vue@3.5.13_typescript@5.1.6__webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-744d81cd"]])

export default __exports__